import { productImageStyles } from "@insite/content-library/Components/ProductImage";
import { css } from "styled-components";

productImageStyles.img = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: auto;
        object-fit: contain;
    `,
};
